export var WidgetTypesEnum;
(function (WidgetTypesEnum) {
    WidgetTypesEnum["EMBED_FEED"] = "embed_feed";
    WidgetTypesEnum["STORYBLOCK"] = "storyblock";
    WidgetTypesEnum["STORYLINK"] = "storylink";
    WidgetTypesEnum["CHANNEL_BUTTON"] = "channel_button";
    WidgetTypesEnum["PROGRAMMATIC"] = "programmatic";
})(WidgetTypesEnum || (WidgetTypesEnum = {}));
export var PlayerPlacementEnum;
(function (PlayerPlacementEnum) {
    PlayerPlacementEnum["TOP_LEFT"] = "top-left";
    PlayerPlacementEnum["TOP_RIGHT"] = "top-right";
    PlayerPlacementEnum["BOTTOM_LEFT"] = "bottom-left";
    PlayerPlacementEnum["BOTTOM_RIGHT"] = "bottom-right";
})(PlayerPlacementEnum || (PlayerPlacementEnum = {}));
export var ResetTransformEnum;
(function (ResetTransformEnum) {
    ResetTransformEnum["ALWAYS"] = "always";
    ResetTransformEnum["FULLSCREEN"] = "fullscreen";
    ResetTransformEnum["NEVER"] = "never";
})(ResetTransformEnum || (ResetTransformEnum = {}));
export const areStoryblockParams = (params) => (params === null || params === void 0 ? void 0 : params.type) === 'storyblock';
